import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-11",
  "use": "icon-attr-shape-11-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-11\"><path d=\"M15.792 5a3.936 3.936 0 0 0-3.93 3.93v7.076c0 .141-.076.27-.198.34l-5.696 3.359A3.94 3.94 0 0 0 4 23.102a3.9 3.9 0 0 0 3.869 3.91 3.94 3.94 0 0 0 2.014-.527l5.713-3.586a.39.39 0 0 1 .396.003l5.71 3.583a3.93 3.93 0 0 0 5.361-1.425 3.87 3.87 0 0 0 .522-1.95 3.94 3.94 0 0 0-1.968-3.405l-5.697-3.359a.39.39 0 0 1-.197-.34V8.931A3.936 3.936 0 0 0 15.793 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol